import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ControlValueAccessor, FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { CheckboxComponent } from '@shared-lib/components/form-components/checkbox/checkbox.component';

@Component({
  selector: 'cp-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  imports: [CheckboxComponent, ReactiveFormsModule],
})
export class CpCheckboxComponent implements ControlValueAccessor, OnInit {
  @Input() label: string;
  @Output() checkedChange = new EventEmitter<boolean>();

  protected readonly ngControl = inject(NgControl, { self: true, optional: true });
  private readonly destroyRef = inject(DestroyRef);

  protected readonly internalControl = new FormControl<boolean | null>(null);

  changeCallback: (value: boolean | null) => void = () => {
    // Empty
  };

  touchCallback: () => void = () => {
    // Empty
  };

  constructor() {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.internalControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.changeCallback(value);
      this.checkedChange.emit(value ?? false);
    });
  }

  writeValue(value: boolean): void {
    if (this.internalControl.value !== value) {
      this.internalControl.setValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: (value: boolean | null) => void): void {
    this.changeCallback = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.touchCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.internalControl.disable();
    } else {
      this.internalControl.enable();
    }
  }
}
